import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { ItemTaskSchedulerInstruction } from '@common/task-scheduler/frontend-shared';
import * as i0 from "@angular/core";
let MpfAppFrontendAdminFeature = /*#__PURE__*/(() => {
  let MpfAppFrontendAdminFeature = class MpfAppFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/app/frontend-admin","featureId":"mpf-app"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineModelInstructions([{
        modelId: 'UserItem',
        targetSlotId: 'sidebar',
        displayContext: ['admin', 'crud'],
        displayInEditModes: ['edit'],
        instructions: [new ItemTaskSchedulerInstruction({})]
      }]);
      functionality.defineModelInstructions([{
        modelId: 'CompanyItem',
        targetSlotId: 'sidebar',
        displayContext: ['admin', 'crud'],
        displayInEditModes: ['edit'],
        instructions: [new ItemTaskSchedulerInstruction({})]
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfAppFrontendAdminFeature_BaseFactory;
        return function MpfAppFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMpfAppFrontendAdminFeature_BaseFactory || (ɵMpfAppFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfAppFrontendAdminFeature)))(__ngFactoryType__ || MpfAppFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfAppFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  };
  MpfAppFrontendAdminFeature = __decorate([ClassName("MpfAppFrontendAdminFeature")], MpfAppFrontendAdminFeature);
  return MpfAppFrontendAdminFeature;
})();
export { MpfAppFrontendAdminFeature };